// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607200404/js/" + chunkId + "." + {"44":"268b7ee6","225":"773167b5","481":"805aee58","486":"fbb7d2fe","770":"fe766622"}[chunkId] + ".0.06253795216520808.chunk.js";
};